import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PermissionEnum } from '@ui/src';
import { dashboardDictionariesApi, PermissionReponse } from './services';

export interface DictionariesState {
  activePermissions?: PermissionEnum[];
  whitelabel?: {
    data: {
      value: Record<string, string>;
    };
  };
}

const initialState: DictionariesState = {
  activePermissions: undefined,
};

export const dashboardDictionariesSlice = createSlice({
  name: 'dashboardDictionaries',
  initialState,
  reducers: {
    setActivePermissions: (state, action: PayloadAction<PermissionEnum[]>) => {
      state.activePermissions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        dashboardDictionariesApi.endpoints.getDashboardPermissions
          .matchFulfilled,
        (state, action: PayloadAction<{ data: PermissionReponse }>) => {
          state.activePermissions = action.payload.data.permissions;

          localStorage.setItem(
            'activePermissions',
            JSON.stringify(action.payload.data.permissions),
          );
        },
      )
      .addMatcher(
        dashboardDictionariesApi.endpoints.getDashboardWhitelabel
          .matchFulfilled,
        (
          state,
          action: PayloadAction<{
            data: {
              data: {
                value: Record<string, string>;
              };
            };
          }>,
        ) => {
          state.whitelabel = action.payload.data;
        },
      );
  },
});

export const { setActivePermissions } = dashboardDictionariesSlice.actions;

export default dashboardDictionariesSlice.reducer;
